import React from "react";
import { GroupListStyled } from "../styles";
const GroupList = React.memo(({ isRow, isStart, children }) => {
    return (React.createElement(GroupListStyled, { isRow: isRow, isStart: isStart }, children));
});
export default GroupList;
